// src/pages/RedirectAfterLogin.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RedirectAfterLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/functionalpagelogin");
  }, [navigate]);

  return null;
};

export default RedirectAfterLogin;
